import { SortByType, ViewType } from './candidates-table.types';

export const isHiresSort = (sort: SortByType) =>
  [
    SortByType.HiredAtDesc,
    SortByType.HiredAtAsc,
    SortByType.JobStartsAtAsc,
    SortByType.JobStartsAtDesc,
  ].includes(sort);

export function isGdprView(view: ViewType): boolean {
  return [
    ViewType.GdprCorrectionCandidates,
    ViewType.GdprRemovalCandidates,
    ViewType.GdprExpiringCandidates,
    ViewType.GdprAwaitingConsentCandidates,
  ].includes(view);
}
